import { axInst } from "../../../Components/Login/Service";

export const funnel_data = async (body) => {
  try {
    const res = await axInst.post("/powerdeck/funnel_data", body);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const funnel_table_data = async (body) => {
  try {
    const res = await axInst.post("/powerdeck/funnel_table_data", body);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const retail_table = async (body) => {
  try {
    const res = await axInst.post("/powerdeck/retail_table", body);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const offtaketable = async (body) => {
  try {
    const res = await axInst.post("/powerdeck/offtake_table", body);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const retail_table_stateOffice = async (body) => {
  try {
    const res = await axInst.post("/powerdeck/retail_table_stateOffice", body);
    return res;
  } catch (error) {
    console.error(error);
  }
};

export const offtake_table_stateOffice = async (body) => {
  try {
    const res = await axInst.post("/powerdeck/offtake_table_stateOffice", body);
    return res;
  } catch (error) {
    console.error(error);
  }
};

export const gtme_performace_table = async (body) => {
  try {
    const res = await axInst.post("/powerdeck/gtme_performace", body);
    return res;
  } catch (error) {
    console.error(error);
  }
};

export const digital_performace_table = async (body) => {
  try {
    const res = await axInst.post("/powerdeck/digital_performace", body);
    return res;
  } catch (error) {
    console.error(error);
  }
};
